import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Auth from '@/store/auth';
import SearchState from '@/store/search';
import { NotFoundMessage } from '@/constants/util';
import Signin from '../views/Signin.vue';
import Forget from '../views/Forget.vue';
import ResetPassword from '../views/ResetPassword.vue';
import NotFound from '../views/NotFound.vue';

import UploadFileScreen from '../views/UploadFileScreen.vue';
import DownloadFileScreen from '../views/DownloadFileScreen.vue';


Vue.use(VueRouter);

const requiresAuthFlag = true;

const routes: Array<RouteConfig> = [
  {
    path: '/signin',
    name: 'Signin',
    component: Signin
  },
  {
    path: '/signin/forget',
    name: 'Forget',
    component: Forget
  },
  {
    path: '/signin/reset_password/:token',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/file/upload',
    name: 'UploadFileScreen',
    component: UploadFileScreen,
    meta: {
      title: 'ファイルアップロード',
      breadcrumbs: [{ name: 'ファイルアップロード' }],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '/file/download',
    name: 'DownloadFileScreen',
    component: DownloadFileScreen,
    meta: {
      title: 'データ検索画面',
      breadcrumbs: [{ name: 'データ検索画面' }],
      requiresAuth: requiresAuthFlag
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: NotFoundMessage,
      requiresAuth: requiresAuthFlag
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

// ログイン状態を確認しログインしていない場合サインイン画面へリダイレクト
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // queryでsearchCondtions: trueを指定していない場合は保持している検索条件をクリアする
    if (SearchState.searchCondition.length > 0 && !to.query.searchConditions) {
      SearchState.clearsearchCondition();
    }
    if (!Auth.isLogin) {
      next({
        path: '/signin',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
